import CreateTemplate from "../../pages/dashboard/exports/CreateTemplate";
import EditTemplate from "../../pages/dashboard/exports/EditTemplate";
import ExportIndex from "../../pages/dashboard/exports/ExportIndex";
import { ALL_ROUTES } from "../AllRoutes";

export const export_routes_group = [
  {
    path: ALL_ROUTES?.DASHBOARD_EXPORT,
    element: ExportIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_EXPORT_CREATE,
    element: CreateTemplate,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_EXPORT_EDIT,
    element: EditTemplate,
  },
];
